import commonComponents from '@zzcbpmDashboard/common/index'

import Vue from 'vue'
const components = require.context('../common', true, /\.vue$/);
//全局注册组件
components.keys().forEach(filename => {
    let arr = filename.replace(/\.\//, '').replace(/\.vue$/, '').split('/');
    let componentName =  arr[arr.length - 1];
    // let componentConfig = components(filename);
    let componentConfig = components(filename).default
    Vue.component(componentName, componentConfig);
})


// WEBPACK FOOTER //
// ./src/digitalHuman/common/index.js